import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/delete.svg'


const _withScopeId = n => (_pushScopeId("data-v-a87c5ca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-4 tw-px-8 tw-box-border" }
const _hoisted_2 = { class: "tw-w-full tw-h-[411px] tw-bg-[#F1F6FB] tw-rounded-lg tw-flex tw-flex-col tw-justify-between tw-gap-4 tw-p-4 tw-box-border" }
const _hoisted_3 = { class: "tw-h-full tw-flex tw-flex-col tw-items-center tw-gap-1" }
const _hoisted_4 = { class: "tw-w-full tw-flex tw-items-center tw-flex-col tw-gap-3" }
const _hoisted_5 = { class: "tw-w-full tw-justify-center tw-items-center tw-flex tw-flex-wrap" }
const _hoisted_6 = {
  key: 0,
  class: "error_msg"
}
const _hoisted_7 = { class: "tw-w-full tw-h-[411px] tw-rounded-lg tw-flex tw-flex-col tw-justify-between tw-gap-4 tw-py-4 tw-box-border" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-2 tw-pb-4 tw-box-border tw-border-b-solid-custom" }
const _hoisted_9 = {
  key: 0,
  class: "tw-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-[#1FB27A] tw-flex tw-flex-col tw-items-center tw-justify-center"
}
const _hoisted_10 = {
  key: 0,
  class: "tw-h-full tw-rounded-lg tw-overflow-y-auto tw-flex tw-flex-col tw-gap-4 tw-pr-2 tw-box-border no-scrollbar"
}
const _hoisted_11 = { class: "tw-flex-row-between" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "tw-w-full tw-flex tw-justify-end tw-items-center tw-gap-3 tw-border-t-dashed-custom tw-pt-4 tw-box-border" }

import { computed, ref, reactive, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import TrashIcon from "@/core/components/icons/TrashIcon.vue";
import AttachmentUploadIcon from "@/core/components/icons/AttachmentUploadIcon.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";
import { PROJECT_STORE } from "@/store/modules/project";
import ProjectDetail from "@/core/uni-components/ProjectDetail.vue";
import { USER_STORE } from "@/store/modules/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadProjectAttachmentsModal',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  isPropertyOwner: {
    type: Boolean,
    default: false,
  },
  projectAttachments: {
    type: Array,
  },
  projectData: {
    type: Object,
    default: null,
  },
},
  emits: ["on-close", "on-success", "on-save"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const store = useStore();
const route = useRoute();

const isSaving = ref(false);

const imageUrl = ref("");
const errorMessage = ref("");
const uploadedImages = ref(null) as any;
const attachmentDataList = ref([]) as any;

const state = reactive({
  loading: false,
});

const propertyId = computed(() => route?.params?.propertyId);

const isAttachmentDataValid = computed(() => {
  if (!attachmentDataList.value || attachmentDataList.value.length === 0) {
    return false;
  }

  return attachmentDataList.value.every(
    (attachment: { propertyId: null; userCategoryName: null }) =>
      attachment.propertyId !== null && attachment.userCategoryName !== null
  );
});

const onCloseModal = () => {
  emits("on-close");
};

const onFileChange = async (event: any) => {
  const fileInput = event.target;
  errorMessage.value = "";
  if (fileInput.files && fileInput.files.length > 0) {
    Array.from(fileInput.files).forEach((file: any) => {
      if (file.type.includes("image")) {
        // Check image size limit (200MB)
        if (file.size <= 200 * 1024 * 1024) {
          imageUrl.value = URL.createObjectURL(file);
          uploadedImages.value = {
            url: imageUrl.value,
            name: file.name,
            imageData: file,
            id: `${file.name}_${Date.now()}`,
          };
        } else {
          errorMessage.value = "Image size exceeds the limit (200MB).";
          // Handle error message or display notification
        }
      } else if (file.type.includes("video")) {
        // Check video size limit (20MB)
        if (file.size <= 10 * 1024 * 1024) {
          uploadedImages.value = {
            type: "video",
            name: file.name,
            imageData: file,
          };
          // Process video file
        } else {
          errorMessage.value = "Video size exceeds the limit (20MB).";
          // Handle error message or display notification
        }
      } else {
        // Allow other file types without size validation
        imageUrl.value = URL.createObjectURL(file);
        uploadedImages.value = {
          url: imageUrl.value,
          name: file.name,
          imageData: file,
        };
      }
    });
  } else {
    console.error("Error: No file selected.");
  }
};
const clearImageUrl = () => {
  imageUrl.value = "";
  errorMessage.value = "";
  uploadedImages.value = null;
};

const addPropertyImage = () => {
  if (uploadedImages.value) {
    attachmentDataList.value.push({
      uploadedImages: { ...uploadedImages.value },
      propertyId: projectProperty.value?.property?.id,
      userCategoryName: null,
    });
    clearImageUrl();
  }
};

const removeImageFromAttachments = (index: number, attachmentId: number) => {
  attachmentDataList.value.splice(index, 1);

  if (!props.isPropertyOwner) {
    cloneAttachmentDataList.value.forEach((attachment: any) => {
      if (attachment.uploadedImages.id === attachmentId) {
        attachment["isDeleted"] = true;
      }
    });
  }
  clearImageUrl();
};

const onSave = async () => {
  isSaving.value = true;
  if (props.isPropertyOwner) {
    if (isAttachmentDataValid.value) {
      await store.dispatch(
        `${PROJECT_STORE}/setProjectAttachments`,
        attachmentDataList.value
      );
    }
  } else {
    try {
      //new attachment add functionality
      const newAttachmentDataList = attachmentDataList.value.filter(
        (attachment: any) => attachment?.uploadedImages.imageData
      );

      for (const attachment of attachmentDataList.value) {
        const existCategory = availableCategoryList.value.find(
          (category: any) => category.label === attachment.userCategoryName
        );
        if (!existCategory) {
          const response = await store.dispatch(
            `${PROJECT_STORE}/attachmentCategory`,
            {
              label: attachment.userCategoryName,
              value: attachment.userCategoryName,
            }
          );
          availableCategoryList.value.push(response);
        }
      }

      let newCreatedAttachment = [];
      if (newAttachmentDataList.length) {
        const formData = new FormData();
        newAttachmentDataList.forEach((attachment: any) => {
          if (attachment.uploadedImages.imageData) {
            formData.append(`files`, attachment.uploadedImages.imageData);
          }
        });
        const uploadMultipleImage = await store.dispatch(
          `${USER_STORE}/uploadMultipleImage`,
          formData
        );

        newCreatedAttachment = uploadMultipleImage.map(
          (item: any, index: number) => ({
            publicUrl: item.publicUrl,
            attachment: item.attachment,
            originalName: item.originalName,
            propertyIds: [
              {
                propertyId: projectProperty.value?.property?.id,
                isDeleted: false,
              },
            ],
            attachmentCategoryId: availableCategoryList.value.find(
              (category: any) =>
                category.label === newAttachmentDataList[index].userCategoryName
            ).id,
            isDeleted: false,
          })
        );
      }

      const removeDataAttachment = [] as any;
      const updatedDataAttachment = [] as any;
      cloneAttachmentDataList.value.forEach((attachment: any, index: any) => {
        let attachmentData;
        if (attachment.isDeleted) {
          attachmentData = {
            id: attachment?.uploadedImages?.id,

            propertyIds: [
              {
                propertyId: projectProperty.value?.property?.id,
                isDeleted: true,
              },
            ],
            isDeleted: true,
          };
          removeDataAttachment.push(attachmentData);
        } else {
          const currentAttachment = attachmentDataList.value.find(
            (att: any) =>
              att?.uploadedImages.id === attachment?.uploadedImages?.id
          );
          if (
            currentAttachment?.userCategoryName &&
            currentAttachment?.userCategoryName !== attachment.userCategoryName
          ) {
            updatedDataAttachment.push({
              id: attachment?.uploadedImages?.id,
              attachment: attachment.uploadedImages.attachment,
              originalName: attachment.uploadedImages.name,
              propertyIds: [
                {
                  id: props.projectData.projectAttachments[0]?.id,
                  propertyId: projectProperty.value?.property?.id,
                  isDeleted: false,
                },
              ],
              attachmentCategoryId: availableCategoryList.value.find(
                (category: any) =>
                  category.label === currentAttachment?.userCategoryName
              ).id,
              isDeleted: false,
            });
          }
        }
      });
      emits("on-save", {
        updatePayload: [
          ...newCreatedAttachment,
          ...removeDataAttachment,
          ...updatedDataAttachment,
        ],
        attachmentData: JSON.parse(JSON.stringify(attachmentDataList.value)),
      });
    } catch (error) {
      console.log("error", error);
    } finally {
      isSaving.value = false;
    }
  }
  isSaving.value = false;
  onCloseModal();
};
const userCategory = [
  {
    name: "Floorplan",
  },
  {
    name: "Garden",
  },
  {
    name: "Materials",
  },
  {
    name: "Maps",
  },
];
const selectedFile = ref([]);
const cloneAttachmentDataList = ref([]);
const availableCategoryList = ref();
const projectProperty = ref();
onMounted(async () => {
  attachmentDataList.value = JSON.parse(
    JSON.stringify(props.projectAttachments)
  );
  if (!props.isPropertyOwner) {
    projectProperty.value = props.projectData
      ? props.projectData?.projectProperties[0]
      : null;
    // attachmentDataList.value = attachmentDataList.value.map((data: any) => {
    //   return {
    //     ...data,
    //     propertyId: data[0],
    //   };
    // });
    availableCategoryList.value = await store.dispatch(
      `${PROJECT_STORE}/getProjectCategoryList`,
      props.projectData.id
    );
    cloneAttachmentDataList.value = JSON.parse(
      JSON.stringify(attachmentDataList.value)
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" quam earum? "),
    _createVNode(GeneralDialog, {
      onOnClose: onCloseModal,
      width: "900px"
    }, {
      body: _withCtx(() => [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Text, {
              variant: "h6",
              textWeight: "600"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Upload images and files")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(Text, {
                variant: "span",
                textColor: "rgba(12, 15, 74, 0.5)",
                textWeight: "500",
                lineHeight: "20px",
                textAlign: "center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Attachments such as images, design ideas and documents help better understand the project and provide increasingly accurate estimates. ")
                ]),
                _: 1
              }),
              _createVNode(AttachmentUploadIcon),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_v_file_input, {
                  class: "tw-max-w-[115px] tw-w-full !tw-cursor-pointer",
                  label: "Upload",
                  "prepend-inner-icon": "mdi-upload",
                  variant: "solo-filled",
                  onChange: onFileChange,
                  "onClick:clear": clearImageUrl,
                  multiple: "",
                  clearable: ""
                }),
                _createElementVNode("div", _hoisted_5, [
                  (imageUrl.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["tw-relative tw-w-[150px] tw-h-[100px] tw-rounded-md tw-overflow-hidden", {
                    'tw-flex tw-items-center tw-gap-2 tw-w-auto tw-h-[30px]':
                      uploadedImages.value?.imageData.type === 'application/pdf' ||
                      uploadedImages.value?.imageData.type === 'application/msword',
                  }])
                      }, [
                        (
                      uploadedImages.value?.imageData.type === 'application/pdf' ||
                      uploadedImages.value?.imageData.type === 'application/msword'
                    )
                          ? (_openBlock(), _createBlock(Text, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(uploadedImages.value.name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_icon, {
                          onClick: clearImageUrl,
                          icon: "mdi-close-circle-outline",
                          class: _normalizeClass(["tw-absolute tw-right-1 tw-top-1 tw-z-20 tw-cursor-pointer", {
                      'tw-relative !tw-right-0 !tw-top-0':
                        uploadedImages.value?.imageData.type === 'application/pdf' ||
                        uploadedImages.value?.imageData.type === 'application/msword',
                    }])
                        }, null, 8, ["class"]),
                        (
                      uploadedImages.value?.imageData.type !== 'application/pdf' &&
                      uploadedImages.value?.imageData.type !== 'application/msword'
                    )
                          ? (_openBlock(), _createBlock(_component_v_img, {
                              key: 1,
                              class: "tw-w-full tw-h-full",
                              "aspect-ratio": "16/9",
                              cover: "",
                              src: imageUrl.value ? imageUrl.value : _ctx.userImage
                            }, null, 8, ["src"]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                (errorMessage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errorMessage.value), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(Button, {
              onClick: addPropertyImage,
              variant: "accent",
              label: attachmentDataList.value.length ? 'ADD ANOTHER' : 'add',
              isActive: uploadedImages.value !== null
            }, null, 8, ["label", "isActive"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Text, {
                variant: "h6",
                textWeight: "600"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(attachmentDataList.value.length
                ? "Uploaded Files"
                : "Your added project attachments will show up here"), 1)
                ]),
                _: 1
              }),
              (attachmentDataList.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(Text, {
                      variant: "xsmall",
                      textColor: "#fff",
                      textWeight: "400"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(attachmentDataList.value.length), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            (attachmentDataList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachmentDataList.value, (attachment, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "tw-w-full tw-flex tw-flex-col tw-gap-1 tw-items-start tw-border-b-solid-custom tw-pb-4 tw-box-border"
                    }, [
                      _createVNode(_component_v_img, {
                        class: _normalizeClass(["tw-rounded-lg", {
                  'tw-hidden':
                    attachment?.uploadedImages?.imageData?.type ===
                      'application/pdf' ||
                    attachment?.uploadedImages?.imageData?.type ===
                      'application/msword',
                }]),
                        width: 156,
                        height: 88,
                        "aspect-ratio": "16/9",
                        cover: "",
                        src: attachment?.uploadedImages?.url
                      }, null, 8, ["class", "src"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(Text, { variant: "span" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(attachment?.uploadedImages?.name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("img", {
                          class: "tw-cursor-pointer",
                          onClick: ($event: any) => (
                    removeImageFromAttachments(
                      index,
                      attachment?.uploadedImages?.id
                    )
                  ),
                          src: _imports_0
                        }, null, 8, _hoisted_12)
                      ]),
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        placeholder: "E.g. Public liability",
                        variant: "outlined",
                        modelValue: attachment.userCategoryName,
                        "onUpdate:modelValue": ($event: any) => ((attachment.userCategoryName) = $event),
                        class: "v-text-custom selectprop_dropdown",
                        "menu-props": { contentClass: 'text__selector' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-chevron-down",
                            id: `menu-activator-${index}`,
                            class: "cursor-pointer"
                          }, null, 8, ["id"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_v_menu, {
                        transition: "slide-y-reverse-transition",
                        class: "slider-menu-active pro_review_drop",
                        activator: `#menu-activator-${index}`,
                        active: true,
                        "menu-props": { contentClass: 'pro_review_drop' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list, { class: "dropdown_selector" }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(userCategory, (item, index) => {
                                return _createVNode(_component_v_list_item, {
                                  "menu-props": { contentClass: 'text__selector' },
                                  key: index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, {
                                      class: "cursor-pointer",
                                      onClick: ($event: any) => (attachment.userCategoryName = item.name)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              }), 64))
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["activator"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("section", _hoisted_13, [
          _createVNode(Button, {
            class: "!tw-w-auto",
            variant: "secondary",
            disabled: isSaving.value,
            label: "Cancel",
            isActive: true,
            onClick: onCloseModal
          }, null, 8, ["disabled"]),
          _createVNode(Button, {
            class: "!tw-w-auto",
            label: "save",
            variant: "accent",
            isLoading: isSaving.value,
            isActive: isAttachmentDataValid.value,
            onClick: onSave
          }, null, 8, ["isLoading", "isActive"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})